import { __decorate } from "tslib";
import { Action, Getter, Mutation, State } from "@/types";
import { service } from "@/services";
export class Absences {
    constructor() {
        this.absences = [];
        this.count = 0;
        this.axiosError = null;
    }
    setItems(absences) {
        this.absences = absences;
    }
    setTotal(count) {
        this.count = count;
    }
    setError(error) {
        this.axiosError = error;
    }
    get list() {
        return this.absences;
    }
    get total() {
        return this.count;
    }
    get errorList() {
        return this.axiosError;
    }
    async get(options) {
        try {
            const data = await service.absences.get(options);
            this.setItems(data.items);
            this.setTotal(data.total);
        }
        catch (error) {
            this.setError(error);
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async add(absences) {
        try {
            await service.absences.add(absences);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
        }
    }
    async edit(absences) {
        try {
            await service.absences.edit(absences);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
        }
    }
    async delete(absences) {
        try {
            await service.absences.delete(absences);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
}
__decorate([
    State()
], Absences.prototype, "absences", void 0);
__decorate([
    State()
], Absences.prototype, "count", void 0);
__decorate([
    State()
], Absences.prototype, "axiosError", void 0);
__decorate([
    Mutation()
], Absences.prototype, "setItems", null);
__decorate([
    Mutation()
], Absences.prototype, "setTotal", null);
__decorate([
    Mutation()
], Absences.prototype, "setError", null);
__decorate([
    Getter()
], Absences.prototype, "list", null);
__decorate([
    Getter()
], Absences.prototype, "total", null);
__decorate([
    Getter()
], Absences.prototype, "errorList", null);
__decorate([
    Action()
], Absences.prototype, "get", null);
__decorate([
    Action()
], Absences.prototype, "add", null);
__decorate([
    Action()
], Absences.prototype, "edit", null);
__decorate([
    Action()
], Absences.prototype, "delete", null);
